import { render, staticRenderFns } from "./modal_incluir_item_comanda_auditoria.vue?vue&type=template&id=5b6c2e99"
import script from "./modal_incluir_item_comanda_auditoria.vue?vue&type=script&lang=js"
export * from "./modal_incluir_item_comanda_auditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports